import React from "react"

const TermsOfService: React.FC = (): JSX.Element => {
  return (
    <section id="terms-of-service" className="mb-8">
      <div className="space-y-6">
        <div>
          <h2 className="text-lg font-bold text-black mb-4">
            3. PHẠM VI THU THẬP THÔNG TIN
          </h2>
          <div className="space-y-3 text-gray-800 text-sm leading-relaxed">
            <p>
              Khi bạn sử dụng các trang web hoặc các ứng dụng của TuTiMi Coffee
              & Tea, TuTiMi Coffee & Tea thu thập một số thông tin về bạn và các
              dịch vụ mà bạn sử dụng.
            </p>
            <p>
              Thông tin TuTiMi Coffee & Tea thu thập được phân loại như sau:
            </p>

            <div>
              <h3 className="font-semibold text-black mb-2 text-sm">
                Thông tin bạn cung cấp cho TuTiMi Coffee & Tea:
              </h3>
              <p className="mb-3">
                TuTiMi Coffee & Tea thu thập thông tin mà bạn cung cấp cho
                TuTiMi Coffee & Tea khi bạn sử dụng các dịch vụ của TuTiMi
                Coffee & Tea. Ví dụ: mua hàng tại cửa hàng, mở Thẻ Thân Thiết,
                đặt hàng tại website này, đăng ký sự kiện, hoặc khi bạn đăng kí
                ứng tuyển nhân sự, cung cấp thông tin đề xuất nhượng quyền.
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-black mb-2 text-sm">
                Thông tin TuTiMi Coffee & Tea thu thập từ bạn:
              </h3>
              <p className="mb-3">
                Khi bạn truy cập các trang web của TuTiMi Coffee & Tea hoặc sử
                dụng dịch vụ tại cửa hàng, TuTiMi Coffee & Tea có thể thu thập
                thông tin về việc truy cập và sử dụng của bạn. Thông tin này bao
                gồm:
              </p>

              <div className="space-y-3">
                <div>
                  <h4 className="font-medium text-black mb-1 italic text-sm">
                    Thông Tin Về Giao Dịch Mua
                  </h4>
                  <p>
                    TuTiMi Coffee & Tea có thể thu thập thông tin về các giao
                    dịch của bạn tại các TuTiMi Coffee & Tea hoặc trên các trang
                    web của TuTiMi Coffee & Tea bao gồm những sản phẩm bạn mua,
                    mức độ thường xuyên bạn mua các sản phẩm, bất kỳ quà tặng
                    hoặc khuyến mại liên quan đến giao dịch mua.
                  </p>
                </div>

                <div>
                  <h4 className="font-medium text-black mb-1 italic text-sm">
                    Thông Tin Về Thiết Bị và Sử Dụng
                  </h4>
                  <p>
                    Khi bạn tải về và cài đặt một trong những ứng dụng di động
                    của TuTiMi Coffee & Tea hoặc sử dụng một máy tính, máy tính
                    bảng, điện thoại thông minh hoặc thiết bị khác để truy cập
                    vào trang web của TuTiMi Coffee & Tea, TuTiMi Coffee & Tea
                    có thể thu thập thông tin về các thiết bị bạn sử dụng và
                    cách bạn sử dụng nó.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TermsOfService
